// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Share_wrapper__J6IKr","iconsWrapper":"Share_iconsWrapper__Fji4l","icon":"Share_icon__baxex","title":"Share_title__1ZFM9","scale":"Share_scale__ZImCD"};